import API_ENDPOINTS from "../config/apiEndpoints";
import { ensureOk, requestWithAuth } from "./apiClient";

export const apiPermisosAusenciaService = {
  save: async (permisoRequest) => {
    const response = await requestWithAuth(API_ENDPOINTS.INCIDENCIAS.CREATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(permisoRequest),
    });
    ensureOk(response, "Error al crear el permiso horario");
    return response.json();
  },

  getAllByID: async (idEmpleado, desde, hasta, size, page) => {
    if (!idEmpleado) {
      return { content: [], totalPages: 0 };
    }

    let endpoint = API_ENDPOINTS.INCIDENCIAS.ALL(idEmpleado);
    const params = [];

    if (desde) params.push(`desde=${desde}`);
    if (hasta) params.push(`hasta=${hasta}`);
    if (Number.isInteger(size)) params.push(`size=${size}`);
    if (Number.isInteger(page)) params.push(`page=${page}`);
    params.push("sort=dia,desc");

    if (params.length > 0) {
      endpoint += `?${params.join("&")}`;
    }

    const response = await requestWithAuth(endpoint, { method: "GET" });
    ensureOk(response, "Error al obtener permisos horarios");
    return response.json();
  },
  deleteByID: async (idPermisosAusencia) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.INCIDENCIAS.DELETE(idPermisosAusencia),
      { method: "DELETE" }
    );
    ensureOk(response, "Error al eliminar el permiso horario");
    return response.json();
  },
};
